/**
 * Exam Configuration
 * Toggle exam security features on/off
 * 
 * To enable features later, simply change the values to `true`
 * 
 * Features:
 * - enableFullscreenCheck: Requires fullscreen mode before starting exam
 * - enableCheatingDetection: Enables camera, face detection, tab switching detection, screen sharing monitoring
 * - enableTimer: Shows countdown timer and enforces time limits
 * - enableSystemChecks: Requires camera, audio, and face detection to pass before starting
 */

export const examConfig = {
    // Enable/disable fullscreen check requirement
    // Set to true to require fullscreen mode
    enableFullscreenCheck: true,

    // Enable/disable cheating detection (camera, face detection, tab switching, screen sharing, etc.)
    // Set to true to enable all cheating detection mechanisms
    enableCheatingDetection: true,

    // Enable/disable timer enforcement
    // Set to true to show countdown timer and auto-submit when time expires
    enableTimer: true,

    // Enable/disable system checks (camera, audio, face detection)
    // Set to true to require all system checks to pass before starting exam
    enableSystemChecks: true,
};
